<template>
  <div>
    <AppLayout>
      <router-view />
    </AppLayout>
    <AppVersionModal />
  </div>
</template> 

<script>
  import AppVersionModal from './components/AppVersionModal.vue';
  export default {
    components: {
      AppVersionModal
    }
}
</script>
